import React, { useEffect, useState } from "react";

/** Component */
import {
  ButtonGroup,
  Button,
  Tooltip,
  Collapse,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import LoadingProgress from "../../commons/LoadingProgress.component";
import { FilterBy } from "../../commons/filter.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icon */
import SegmentIcon from "@mui/icons-material/Segment";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

/** Hook */
import { useParamFilter } from "../../commons/customHook";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import moment from "moment";

/** API & Actions */
import { getExtPrice, getCustomers, getInventory, getCurrency, getFlight, getSaleType, getLoadingType, createExtPrice, getExtPriceById, deleteExtPrice, updateExtPrice } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
import { useTranslation } from "react-i18next";

/** Init table header  */
const tblHeader = ["STT", "Tên khách hàng", "Kho hàng hoá", "Mã tuyến bay", "Hình thức tra nạp", "Ngày áp dụng", "Ngày hết hạn", "Tiền tệ", "Đơn giá", "Hiệu lực"];

/** Init Filter */

const initialFilter = {
  customer: null,
  customer_id: null,
  inventory: null,
  inventory_id: null,
  // eff_date: "",
  // exp_date: "",
};

const ExtPrice = () => {
  /** Hook */
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [t] = useTranslation();

  /** State */
  const [isSearchOpen, setSearchOpen] = useState(true);
  const [isAddOpen, setAddOpen] = useState(false);
  const [isEditOpen, setEditOpen] = useState(false);
  const { fetchData, data, page, perPage, setPage, setPerPage, total, loading } = useParamFilter({ page: 1, per_page: 50 }, getExtPrice);
  const [filter, setFilter] = useState({ ...initialFilter });
  const [sltRow, setSltRow] = useState(null);
  /** Component Init
   * - Set component title
   * - Call extprice to get data
   */

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN GIÁ ÁP DỤNG ĐẶC BIỆT"));
    fetchData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** Funtions */

  const handleSearch = () => {
    fetchData(filter);
  };

  const handleSelectRow = (id) => {
    getExtPriceById(id).then((res) => {
      if (res.code === 200) {
        setSltRow(res.data);
        setEditOpen(!isEditOpen);
      }
    });
  };

  const hanldeAddProcess = (inputData) => {
    createExtPrice({
      customer_id: inputData?.customer_id,
      customer_name: inputData?.customer_name,
      inventory_id: inputData?.inventory_id,
      inventory_name: inputData?.inventory_name,
      hydrant_sys: inputData?.hydrant_sys,
      loadingtype_id: inputData?.loadingtype?.id,
      saletype_id: inputData?.saletype?.id,
      eff_date: inputData?.eff_date,
      exp_date: inputData?.exp_date,
      currency_code: inputData?.currency_code,
      price: inputData?.price,
      flight_ids: inputData?.flights.map((item) => item.id),
    })
      .then((res) => {
        enqueueSnackbar(res.message);
        if (res.code === 200) {
          setAddOpen(!isAddOpen);
          /** Update index list */
          fetchData(filter);
        }
      })
      .catch((e) => enqueueSnackbar(e));
  };

  const handleEditProcess = (inputData) => {
    updateExtPrice(inputData.id, {
      customer_id: inputData?.customer_id,
      customer_name: inputData?.customer_name,
      inventory_id: inputData?.inventory_id,
      inventory_name: inputData?.inventory_name,
      hydrant_sys: inputData?.hydrant_sys,
      loadingtype_id: inputData?.loadingtype?.id,
      saletype_id: inputData?.saletype?.id,
      eff_date: inputData?.eff_date,
      exp_date: inputData?.exp_date,
      currency_code: inputData?.currency_code,
      price: inputData?.price,
      flight_ids: inputData?.flights.map((item) => item.id),
    })
      .then((res) => {
        enqueueSnackbar(res.message);
        if (res.code === 200) {
          setEditOpen(!isEditOpen);
          /** Update index list */
          fetchData(filter);
        }
      })
      .catch((e) => enqueueSnackbar(e));
  };

  const handleDeleteProcess = (id) => {
    deleteExtPrice(id).then((res) => {
      enqueueSnackbar(res.message);
      if (res.code === 200) {
        setEditOpen(!isEditOpen);
        /** Update index list */
        fetchData(filter);
      }
    });
  };

  const handleClose = () => {
    setAddOpen(false);
    setEditOpen(false);
  };

  return (
    <div>
      {/* Set Button Header */}
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button
            onClick={() => {
              setSltRow(null);
              setAddOpen(!isAddOpen);
            }}
          >
            <Tooltip title="Thêm giá áp dụng đặt biệt">
              <PlaylistAddIcon />
            </Tooltip>
          </Button>
          <Button onClick={() => setSearchOpen((prev) => !prev)}>
            <Tooltip title="Thư mục">
              <SegmentIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <Collapse in={isSearchOpen} align="left" style={{ marginLeft: 5 }}>
        <FilterBy
          label={t("Khách hàng")}
          value={filter.customer}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, customer: newValue, customer_id: newValue ? newValue.id : null }))}
          getDataFunc={() => getCustomers()}
          sx={{ display: "inline-flex", width: 250, margin: "5px" }}
        />
        <FilterBy
          label={t("Kho hàng")}
          getDataFunc={() => getInventory()}
          value={filter.inventory}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, inventory: newValue, inventory_id: newValue ? newValue.id : null }))}
          sx={{ display: "inline-flex", width: 250, margin: "5px" }}
        />

        {/* <CustomDatePicker label={t("Từ ngày")} value={filter.eff_date} onChange={(value) => setFilter((prev) => ({ ...prev, eff_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
        <CustomDatePicker label={t("Đến ngày")} value={filter.exp_date} onChange={(value) => setFilter((prev) => ({ ...prev, exp_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} /> */}
        <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
          {"Tìm kiếm"}
        </Button>
      </Collapse>
      {/* Main Table */}
      {loading ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {tblHeader.map((item, id) => (
                  <TableCell key={id} style={{ border: "0.5px solid lightgray" }}>
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data.map((item, id) => (
                  <TableRow key={id} onClick={() => handleSelectRow(item.id)}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{item.id}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                      {item.customer_name}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{item.inventory_name}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{`${item.flights.map((subitem) => subitem.flight_no)}`}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{item.hydrant_sys === 2 ? "Xe tra nạp" : "Tra nạp ngầm"}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{moment(item.eff_date).format("DD/MM/YYYY HH:mm:ss")}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{moment(item.exp_date).format("DD/MM/YYYY HH:mm:ss")}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{item.currency_code}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                      {item.price.toLocaleString(item.currency === "VND" ? "de-DE" : "ja-JP", { minimumFractionDigits: item.currency === "USD" ? 2 : 0 })}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{t(item.status)}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
      <AddExtPrice isAddOrEditOpen={isAddOpen} initData={null} onClose={handleClose} onProcess={hanldeAddProcess} />
      <EditExtPrice isAddOrEditOpen={isEditOpen} initData={sltRow} onClose={handleClose} onProcess={handleEditProcess} onDelete={handleDeleteProcess} />
    </div>
  );
};

export default ExtPrice;

/** Edit Form to Add or Edit ExtPrice */

const AddExtPrice = ({ isAddOrEditOpen, initData, onClose, onProcess }) => {
  /** State */
  const [inputData, setInputData] = useState({
    id: null,
    customer: null,
    customer_id: null,
    customer_name: null,
    inventory_id: null,
    inventory_name: null,
    flights: [],
    /**
     * hydrant_sys
     * 2: Refueller
     * 3: Hydrant
     */
    hydrant_sys: 2,
    eff_date: null,
    exp_date: null,
    price: 0,
    currency: null,
    currency_code: null,
  });

  return (
    <Dialog open={isAddOrEditOpen} onClose={onClose} fullWidth>
      <DialogTitle align="center"> "TẠO MỚI GIÁ BÁN ÁP DỤNG ĐẶC BIỆT"</DialogTitle>
      <DialogContent>
        <div style={{ display: "grid", rowGap: 10, marginTop: 10 }}>
          <FilterBy
            label={"Khách hàng"}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, customer: option.find((item) => item.id === inputData.customer_id) }))}
            getDataFunc={() => getCustomers({ status: 1 })}
            value={inputData.customer}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, customer: newValue, customer_id: newValue ? newValue.id : null, customer_name: newValue ? newValue.name : null }))}
          />
          <FilterBy
            label={"Kho xuất"}
            getDataFunc={() => getInventory({ status: 1 })}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, inventory: option.find((item) => item.id === inputData.inventory_id) }))}
            value={inputData.inventory}
            onChange={(e, newValue) =>
              setInputData((prev) => ({
                ...prev,
                inventory: newValue,
                inventory_id: newValue ? newValue.id : null,
                inventory_name: newValue ? newValue.name : null,
                hydrant_sys: newValue ? parseInt(newValue.whtype) : null,
              }))
            }
          />
          <div style={{ display: "flex", columnGap: 11 }}>
            <FilterBy
              label={"Phương thức bán"}
              setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, loadingtype: option.find((item) => item.id === inputData.loadingtype_id) }))}
              getDataFunc={() => getLoadingType({ status: 1 })}
              value={inputData.loadingtype}
              onChange={(e, newValue) => setInputData((prev) => ({ ...prev, loadingtype: newValue }))}
              fullWidth
            />
            <FilterBy
              label={"Loại hình bán"}
              setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, saletype: option.find((item) => item.id === inputData.saletype_id) }))}
              getDataFunc={() => getSaleType({ status: 1 })}
              value={inputData.saletype}
              onChange={(e, newValue) => setInputData((prev) => ({ ...prev, saletype: newValue }))}
              fullWidth
            />
          </div>
          <div style={{ display: "flex", columnGap: 11 }}>
            <CustomDatePicker
              format="DD/MM/YYYY HH:mm:ss"
              outputFormat="YYYY-MM-DD HH:mm:ss"
              label={"Ngày hiệu lực"}
              value={inputData.eff_date}
              onChange={(value) => setInputData((prev) => ({ ...prev, eff_date: value }))}
              sx={{ width: "49%" }}
            />

            <CustomDatePicker
              format="DD/MM/YYYY HH:mm:ss"
              outputFormat="YYYY-MM-DD HH:mm:ss"
              label={"Ngày hết hiệu lực"}
              value={inputData.exp_date}
              onChange={(value) => setInputData((prev) => ({ ...prev, exp_date: value }))}
              sx={{ width: "49%" }}
            />
          </div>
          <div style={{ display: "flex", columnGap: 11 }}>
            <FilterBy
              label={"Tiền tệ"}
              setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, currency: option.find((item) => item.code === inputData.currency_code) }))}
              getDataFunc={() => getCurrency({ status: 1 })}
              value={inputData.currency}
              getOptionLabel={(option) => `${option.id} - ${option.code}` || ""}
              onChange={(e, newValue) => setInputData((prev) => ({ ...prev, currency: newValue, currency_code: newValue ? newValue.code : null }))}
              fullWidth
            />
            <TextField
              InputLabelProps={{ shrink: true }}
              InputProps={{ align: "right" }}
              label={"Đơn giá"}
              fullWidth
              value={inputData.price}
              onChange={(e) => setInputData((prev) => ({ ...prev, price: e.target.value }))}
            />
          </div>
          <FilterBy
            label={"Số hiệu chuyến bay"}
            value={inputData.flights}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, flights: option.find((item) => item.id === inputData.flights) }))}
            getDataFunc={() => getFlight({ status: 1, organization_id: inputData.inventory?.organization_id, customer_id: inputData.customer_id })}
            triggerGetDataFunc={Boolean(inputData.inventory && inputData.customer_id)}
            getDataDependencies={[inputData.inventory, inputData.customer_id]}
            getOptionLabel={(option) => (option ? `${option.id} - ${option.flight_no} - ${option.route}` : "")}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, flights: newValue }))}
            fullWidth
            multiple
          />
        </div>
      </DialogContent>
      <DialogActions style={{ marginRight: 17 }}>
        <Button variant="outlined" color="error" onClick={onClose}>
          Thoát
        </Button>
        <Button variant="outlined" color="success" onClick={() => onProcess(inputData)}>
          Tạo mới
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const EditExtPrice = ({ isAddOrEditOpen, initData, onClose, onProcess, onDelete }) => {
  /** State */
  const [inputData, setInputData] = useState({
    id: null,
    customer: null,
    customer_id: null,
    customer_name: null,
    inventory_id: null,
    inventory_name: null,
    flights: [],
    /**
     * hydrant_sys
     * 2: Refueller
     * 3: Hydrant
     */
    hydrant_sys: 2,
    eff_date: null,
    exp_date: null,
    price: 0,
    currency: null,
    currency_code: null,
  });

  /** Init state */
  useEffect(() => {
    if (!initData) return;
    else setInputData(initData);
  }, [initData]);

  return (
    <Dialog open={isAddOrEditOpen} onClose={onClose} fullWidth>
      <DialogTitle align="center">CẬP NHẬT GIÁ BÁN ÁP DỤNG ĐẶC BIỆT</DialogTitle>
      <DialogContent>
        <div style={{ display: "grid", rowGap: 10, marginTop: 10 }}>
          <FilterBy
            label={"Khách hàng"}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, customer: option.find((item) => item.id === inputData.customer_id) }))}
            getDataFunc={() => getCustomers({ status: 1 })}
            value={inputData.customer}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, customer: newValue, customer_id: newValue ? newValue.id : null, customer_name: newValue ? newValue.name : null }))}
          />
          <FilterBy
            label={"Kho xuất"}
            getDataFunc={() => getInventory({ status: 1 })}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, inventory: option.find((item) => item.id === inputData.inventory_id) }))}
            value={inputData.inventory}
            onChange={(e, newValue) =>
              setInputData((prev) => ({
                ...prev,
                inventory: newValue,
                inventory_id: newValue ? newValue.id : null,
                inventory_name: newValue ? newValue.name : null,
                hydrant_sys: newValue ? parseInt(newValue.whtype) : null,
              }))
            }
          />
          <div style={{ display: "flex", columnGap: 11 }}>
            <FilterBy
              label={"Phương thức bán"}
              setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, loadingtype: option.find((item) => item.id === inputData.loadingtype_id) }))}
              getDataFunc={() => getLoadingType({ status: 1 })}
              value={inputData.loadingtype}
              onChange={(e, newValue) => setInputData((prev) => ({ ...prev, loadingtype: newValue }))}
              fullWidth
            />
            <FilterBy
              label={"Loại hình bán"}
              setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, saletype: option.find((item) => item.id === inputData.saletype_id) }))}
              getDataFunc={() => getSaleType({ status: 1 })}
              value={inputData.saletype}
              onChange={(e, newValue) => setInputData((prev) => ({ ...prev, saletype: newValue }))}
              fullWidth
            />
          </div>
          <div style={{ display: "flex", columnGap: 11 }}>
            <CustomDatePicker
              format="DD/MM/YYYY HH:mm:ss"
              outputFormat="YYYY-MM-DD HH:mm:ss"
              label={"Ngày hiệu lực"}
              value={inputData.eff_date}
              onChange={(value) => setInputData((prev) => ({ ...prev, eff_date: value }))}
              sx={{ width: "49%" }}
            />

            <CustomDatePicker
              format="DD/MM/YYYY HH:mm:ss"
              outputFormat="YYYY-MM-DD HH:mm:ss"
              label={"Ngày hết hiệu lực"}
              value={inputData.exp_date}
              onChange={(value) => setInputData((prev) => ({ ...prev, exp_date: value }))}
              sx={{ width: "49%" }}
            />
          </div>
          <div style={{ display: "flex", columnGap: 11 }}>
            <FilterBy
              label={"Tiền tệ"}
              setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, currency: option.find((item) => item.code === inputData.currency_code) }))}
              getDataFunc={() => getCurrency({ status: 1 })}
              value={inputData.currency}
              getOptionLabel={(option) => `${option.id} - ${option.code}` || ""}
              onChange={(e, newValue) => setInputData((prev) => ({ ...prev, currency: newValue, currency_code: newValue ? newValue.code : null }))}
              fullWidth
            />
            <TextField
              InputLabelProps={{ shrink: true }}
              InputProps={{ align: "right" }}
              label={"Đơn giá"}
              fullWidth
              value={inputData.price}
              onChange={(e) => setInputData((prev) => ({ ...prev, price: e.target.value }))}
            />
          </div>
          <FilterBy
            label={"Số hiệu chuyến bay"}
            value={inputData.flights}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, flights: option.find((item) => item.id === inputData.flights) }))}
            getDataFunc={() => getFlight({ status: 1, organization_id: inputData.inventory?.organization_id, customer_id: inputData.customer_id })}
            triggerGetDataFunc={Boolean(inputData.inventory && inputData.customer_id)}
            getDataDependencies={[inputData.inventory, inputData.customer_id]}
            getOptionLabel={(option) => (option ? `${option.id} - ${option.flight_no} - ${option.route}` : "")}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, flights: newValue }))}
            fullWidth
            multiple
          />
        </div>
      </DialogContent>
      <DialogActions style={{ marginRight: 17 }}>
        <Button variant="outlined" color="error" onClick={onClose}>
          Thoát
        </Button>
        {inputData.status !== "DELETED" && (
          <>
            <Button variant="outlined" color="success" onClick={() => onDelete(inputData?.id)}>
              Huỷ hiệu lực
            </Button>
            <Button variant="outlined" color="success" onClick={() => onProcess(inputData)}>
              Cập nhật
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
